/**
 * VirtualFAE-specific config getters.
 *
 * All values are sourced from the auto-generated `src/temp/config.js` module,
 * which is rebuilt at bootstrap time from REACT_APP_* environment variables.
 * Mirrors the Documents Hub `src/config.js` pattern but adapted for the
 * Dev2.0 JSS config-import convention (`import config from '../temp/config'`).
 */

import config from '../temp/config';

/**
 * Returns the `data` payload consumed by the VirtualFAE wrapper component.
 * `redirectUrl` is sourced from REACT_APP_SUPPORT_ORIGIN (the canonical Arm
 * Support origin for this environment), so a single env var drives both the
 * widget redirect and any other support links.
 *
 * @returns {{ appName: string, redirectUrl: string }}
 */
export function getVirtualFAEConfig() {
  return {
    appName: config.REACT_APP_VIRTUAL_FAE_APP_NAME,
    redirectUrl: config.REACT_APP_SUPPORT_ORIGIN,
  };
}

export function getVirtualFAEScriptUrl() {
  return config.REACT_APP_VIRTUAL_FAE_SCRIPT_URL;
}

export function getIsAIAssistanceEnabled() {
  return config.REACT_APP_AI_ASSISTANCE_ENABLED === 'true';
}

export function getIsCheckEntitlementsEnabled() {
  return config.REACT_APP_CHECK_ENTITLEMENTS_ENABLED === 'true';
}

export function getEntitlementsBaseUrl() {
  return config.REACT_APP_ENTITLEMENTS_BASE_URL || '';
}

export function getEntitlementsCacheKey() {
  return config.REACT_APP_CACHE_STORAGE_KEY || 'entitlements-cache';
}

export function getEntitlementsCacheTtlMs() {
  const ttlMinutes = parseInt(config.REACT_APP_ENTITLEMENTS_CACHE_TTL_MINS, 10);
  return Number.isNaN(ttlMinutes) ? 60 * 60 * 1000 : ttlMinutes * 60 * 1000;
}
